<template>
    <v-container>
      <v-app-bar scroll-behavior="elevate">
        <template v-slot:prepend>
          <v-app-bar-title class="font-weight-black">
            
          </v-app-bar-title>
        </template>
      </v-app-bar>
    </v-container>
    
    <v-container class="middle-of-page">
      <router-link to="/" class="">
        <img src='/w_icon_medium.png' class="icon-logo">
      </router-link>
      <v-card class="mx-auto my-8" max-width="344">
        <v-card-text>
          <v-form @submit.prevent="submitForm">
            <v-text-field
              label="Username"
              id="username"
              name="username"
              type="text"
              autocomplete="username"
              v-model="user_name"
            ></v-text-field>
            <v-text-field 
              label="Password" 
              id="password"
              name="password"
              type="password"
              autocomplete="current-password" 
              v-model="password"
            ></v-text-field>
            <v-btn 
              class="mt-2 font-weight-black" 
              type="submit" 
              v-on:click="submitForm"
            >Login</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
import { mapMutations } from 'vuex';


export default {
  data() {
    return {
      user_name: '',
      password: '',
    }
  },
  methods: {
    ...mapMutations(["setUser", "setToken", "setRefreshToken", "showSnackbar"]),
    async submitForm(e) {
      try {
        e.preventDefault();
        const response = await axios.post(
          "/auth/",
          {
            user_name: this.user_name,
            password: this.password
          });
          const access_token = response.data.access_token;
          const refresh_token = response.data.refresh_token;
          const user = response.data.user;

          if(access_token != null){
            this.setUser(user);
            this.setToken(access_token);
            this.setRefreshToken(refresh_token);
            this.$router.push('/dashboard');
          }
          
        
      } catch (error) {
        this.showSnackbar({ message: 'Login failed' });
      }
      
    },
  }, 
}
</script>


<style scoped>
.logo{
  
  font-size: 60px;
}

.icon-logo{
  width: 50px;
}

.middle-of-page{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

</style>